/**
 * 取引先名を「日本語 (English)」併記形式で組み立てる。
 *
 * ベトナム人従業員が漢字の取引先名を読めない問題を解決するため、
 * 一覧・選択肢・確認ダイアログなど画面表示するすべての箇所でこのヘルパーを通す。
 *
 * - `en` が null / undefined / 空文字なら括弧を付けずに日本語のみ返す。
 * - 「株式会社」「Co., Ltd.」は併記しない (en 側は本体名のみを格納する規約)。
 *
 * @param jp 日本語の取引先名 (clients.name)
 * @param en ローマ字の取引先名 (clients.name_en)
 * @returns 表示用文字列
 *
 * @example
 *   formatClientName('株式会社 明石資材', 'Akashi Shizai')
 *     // => '株式会社 明石資材 (Akashi Shizai)'
 *   formatClientName('株式会社 ABC', null)
 *     // => '株式会社 ABC'
 */
export function formatClientName(jp: string, en?: string | null): string {
  const trimmed = en?.trim();
  return trimmed ? `${jp} (${trimmed})` : jp;
}
